import { render } from "./TodoListItem.vue?vue&type=template&id=8e9613ce&scoped=true"
import script from "./TodoListItem.vue?vue&type=script&lang=js"
export * from "./TodoListItem.vue?vue&type=script&lang=js"

import "./TodoListItem.vue?vue&type=style&index=0&id=8e9613ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e9613ce"]])

export default __exports__